import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ResourceSharingOffer,
  UserRapidoResourceSharingRequest,
} from 'app/entity/models/rapido-offer';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class RapidoOffersService {
  private readonly offersUrl = 'api/search-result/rapido/resources/rs-offers';
  private readonly requestsUrl = 'api/search-result/rapido/users/rs-requests';

  // TODO delete after API is complete
  public static offersMock: ResourceSharingOffer[] = [
    {
      policyId: 'string',
      policyType: 'string',
      supplyTime: 0,
      loanPeriod: 0,
      expiryTime: 0,
      cost: 'string',
      currency: 'string',
      allowRenewal: true,
      maximumRenewalsAllowed: 0,
      allowAutomatedRenewal: true,
      availableMmsId: 'string',
      podId: 'string',
      podName: 'string',
      rapidoInd: true,
      unavailableResource: true,
      eBookOffer: true,
      puaPod: true,
      pickupMembers: [
        {
          value: 'string',
          description: 'string',
        },
      ],
      pickupLocations: [
        {
          value: 'string',
          description: 'string',
        },
      ],
    },
  ];

  public static responseMock: UserRapidoResourceSharingRequest = {
    rsOffer: {
      policyId: '',
      policyType: '',
      supplyTime: 0,
      loanPeriod: 0,
      expiryTime: 0,
      cost: '',
      currency: '',
      allowRenewal: false,
      maximumRenewalsAllowed: 0,
      allowAutomatedRenewal: false,
      availableMmsId: '',
      podId: '',
      podName: '',
      rapidoInd: false,
      unavailableResource: false,
      eBookOffer: false,
      puaPod: false,
      pickupMembers: [],
      pickupLocations: [],
    },
    userRsRequest: {
      requestId: '',
      externalId: '',
      requestMedia: '',
      format: {
        value: '',
        desc: '',
      },
      pickupLocationType: '',
      pickupLocation: {
        value: '',
        desc: '',
      },
      rsNotes: [],
      title: '',
      author: '',
      publicationYear: '',
      publisher: '',
      placeOfPublication: '',
      specificEdition: false,
      volume: 0,
    },
    recordId: '',
  };

  constructor(private readonly http: HttpClient) {}

  public getOffers(recordId: string): Observable<ResourceSharingOffer[]> {
    return of(RapidoOffersService.offersMock);
    // return this.http
    //   .get<ResourceSharingOffer[]>(`${this.offersUrl}/${recordId}`)
    //   .pipe(
    //     catchError(() => {
    //       return of([]);
    //     })
    //   );
  }

  public placeRequest(payload: UserRapidoResourceSharingRequest) {
    return of(RapidoOffersService.responseMock);
    // return this.http.post<any>(this.requestsUrl, payload);
  }
}
